<template>
  <div class="uptphone">
    <b>输入短信验证码</b>
    <p style="margin-bottom: 0.55rem">
      验证码已发送至您的手机
      <span>
        {{ mobile.slice(0, 3) }}&nbsp;{{ mobile.slice(3, 7) }}&nbsp;{{ mobile.slice(7, 11) }}
      </span>
    </p>
    <div class="codeWrap" v-show="imgCodeWrapFlag">
      <div class="inputWrap">
        <input
          placeholder="图形验证码"
          maxlength="4"
          v-model="imgCodeValue"
          @keyup="imgCodeChange"
        />
        <img
          class="del-btn"
          src="../../assets/images/close.png"
          v-if="imgCodeFlag"
          @click="clearImgCode"
        />
      </div>
      <div class="codeImg" ref="codeImg" @click="getCodeImg">
        <img :src="codeImg" />
      </div>
    </div>
    <security-code v-model="authCode" :code="authCode" :type="typeFa" :number="num"></security-code>
    <i class="countdown" v-if="time != 0">{{ time }}s后重新发送</i>
    <i class="countdown sendAgain" v-else-if="time == 0" @click="sendAgain">重新发送</i>
    <!--<button class="secuCode">获取验证码</button>-->
  </div>
</template>

<script>
import securityCode from '../common/securityCode'
import {
  checkAgent,
  unencryption,
  setCookie,
  getCookie,
  isWeixin,
  fenxiang,
  basepath,
  random_string
} from '../../assets/common/js/config'
import qs from 'qs'
export default {
  name: 'authCode',
  components: {
    securityCode
  },
  data() {
    return {
      authCode: '',
      time: 60,
      typeFa: 'security',
      num: 6,
      mobile: unencryption(sessionStorage.getItem('ckys_wap_tel')),
      imgCodeValue: '',
      imgCodeFlag: false,
      codeImg: '',
      imgCodeWrapFlag: false
    }
  },
  mounted: function () {
    this.countdown()
    this.getCodeImg()
    if (isWeixin()) {
      fenxiang({ path: 'authCode' })
    }
  },
  destroyed() {
    this.$toast.clear()
    this.$dialog.close()
  },
  watch: {
    authCode: function (n) {
      if (n.length >= this.num) {
        this.login()
      }
    }
  },
  methods: {
    // 获取图形验证码
    getCodeImg() {
      let width = this.$refs.codeImg.clientWidth
      let height = this.$refs.codeImg.clientHeight
      this.timeout = new Date().getTime() + '' + random_string(16)
      this.codeImg = this.$ajax.getValidateCode_URL(
        'sessionid=' + this.timeout + '&width=' + width + '&height=' + height
      )
    },
    // 检测图形验证码-值改变
    imgCodeChange() {
      this.imgCodeFlag = this.imgCodeValue ? true : false
      this.checkInfo()
    },
    // 检测手机号、图形验证码长度
    checkInfo: function () {
      this.passFlag = this.imgCodeValue.length == 4 ? true : false
    },
    clearImgCode() {
      this.imgCodeValue = ''
      this.imgCodeFlag = false
      this.checkInfo()
    },
    code() {
      let type, area_code, url
      this.mobile = unencryption(sessionStorage.getItem('ckys_wap_tel'))
      type = 3
      area_code = sessionStorage.getItem('ckys_wap_area_code')

      url =
        this.$ajax.getValidCode_URL +
        '?newVersion=1&mobile=' +
        this.mobile +
        '&code=' +
        this.imgCodeValue +
        '&sessionid=' +
        this.timeout +
        '&type=' +
        type +
        '&area_code=' +
        area_code
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          this.time = 60
          this.countdown()
        } else if (res.data.code == '10011') {
          this.clearImgCode()
          this.getCodeImg()
        }
      })
    },
    login() {
      var url = this.$ajax.wapLogin_URL
      var urlCode =
        this.$ajax.smsCodeVerify_URL + '?mobile=' + this.mobile + '&code=' + this.authCode
      var data = {
        mobile: this.mobile,
        code: this.authCode
      }
      if (this.$route.query.acttype == 'hc_welfare') {
        url = this.$ajax.login_URL
      } else if (this.$route.query.acttype == 'ck_group') {
        url = this.$ajax.loginCkGroup_URL
        data.groupid = this.$route.query.groupid
      } else if (this.$route.query.acttype == 'hc_welfare_private') {
        url = this.$ajax.loginAdactlinkcart_URL
      } else {
        if (getCookie('shareToken')) data.utoken = getCookie('shareToken')
        if (getCookie('shareCkToken')) data.ucktoken = getCookie('shareCkToken')
      }
      this.$customRequestAjax.get(urlCode).then((res) => {
        if (res.data.code === 200) {
          var routeValue = '/' + this.$route.query.routeval
          this.$customRequestAjax.post(url, data).then((res) => {
            if (res.data.code === 200) {
              if (this.$route.query.acttype == 'hc_welfare') {
                if (res.data.token) sessionStorage.setItem('ck_utoken', res.data.token)
                if (res.data.status == 1)
                  window.location.replace(
                    '/static/wx/html/meeting/exclusive-gift.html?acttype=' +
                      (this.$route.query.acttype || '') +
                      (this.$route.query.hc_share ? '&hc_share=' + this.$route.query.hc_share : '')
                  )
                return
              }
              if (this.$route.query.acttype == 'ck_group') {
                if (res.data.token) sessionStorage.setItem('ck_utoken', res.data.token)
                if (res.data.status == 1) {
                  if (routeValue == '/html' && localStorage.getItem('htmlurl')) {
                    window.location.replace(localStorage.getItem('htmlurl'))
                  } else {
                    this.$router.replace('/')
                  }
                } else {
                  this.$toast('很遗憾，您没有参与权限')
                  setTimeout(() => {
                    this.$app.goIndex()
                  }, 3000)
                }
                return
              }
              if (this.$route.query.acttype == 'hc_welfare_private') {
                if (res.data.token) sessionStorage.setItem('ck_utoken', res.data.token)
                this.$toast(res.data.msg)
                setTimeout(() => {
                  this.$app.argFunc(() => {
                    window.location.replace('/static/wx/html/20251111/act11_private.html')
                  })
                })
                return
              }
              this.waptoken.setwapid(res.data.data.token)
              setCookie('wxmalltoken', res.data.data.token)
              setCookie('ndoresult', JSON.stringify(res.data.data.ndo_result))
              this.dataCollection()
              sessionStorage.removeItem('ckys_wap_tel')
              sessionStorage.removeItem('ckys_wap_security_code')
              sessionStorage.removeItem('ckys_wap_area_code')
              sessionStorage.removeItem('ckys_wap_sessionid')
              // console.log(JSON.parse(res.data.data.temp_result))
              if (this.$route.query.routeval === 'ndoresult') {
                let resultid = this.$route.query.resultid
                let skintype = this.$route.query.skintype
                this.$customRequestAjax
                  .post(this.$ajax.bindaxaminresult_URL, { resultid: resultid })
                  .then((res) => {
                    if (res.data.code === 200) {
                      setCookie(
                        'ndoresult',
                        JSON.stringify({
                          resultid: resultid,
                          skin_type: skintype
                        })
                      )
                      this.$router.replace({
                        path: 'ndoresult',
                        query: { id: resultid }
                      })
                    }
                  })
              } else if (routeValue == '/html') {
                if (localStorage.getItem('htmlurl')) {
                  var pathvalue = localStorage.getItem('htmlurl')
                  window.location.replace(pathvalue)
                } else {
                  this.$router.replace({
                    path: '/'
                  })
                }
              } else {
                console.log(this.$store.state.pathValue)
                this.$router.replace({
                  path: routeValue || '/',
                  query: this.$store.state.pathValue ? JSON.parse(this.$store.state.pathValue) : {}
                })
              }
            } else if (res.data.code === 300) {
              setTimeout(function () {
                location.replace('//a.app.qq.com/o/simple.jsp?pkgname=com.ckc.ckys')
              }, 1000)
            }
          })
        }
      })
    },
    // 埋点-登录
    dataCollection() {
      let userId = getCookie('wxmalltoken')
      gio('setUserId', userId)
    },
    countdown: function () {
      var that = this
      var timer = setInterval(function () {
        that.time--
        if (that.time <= 0) {
          that.time = 0
          if (!that.imgCodeWrapFlag) {
            that.imgCodeWrapFlag = true
          }
          clearInterval(timer)
        }
      }, 1000)
    },
    sendAgain: function () {
      if (!this.passFlag) {
        this.$toast('请先输入图片验证码')
        return
      }
      this.code()
    }
  }
}
</script>

<style scoped lang="scss">
.uptphone {
  flex: 1;
  background: #fff;
  padding: 0.38rem 0.3rem 0;
  p {
    font-size: 16px;
    color: #888888;
    line-height: 22px;
    margin-top: 0.03rem;
    span {
      color: #333333;
    }
  }
  b {
    display: block;
    font-size: 29px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 41px;
  }
  .countdown {
    position: relative;
    z-index: 10;
    font-size: 0.12rem;
    color: #adadad;
    font-style: normal;
    display: block;
    margin-top: 0.19rem;
    &.sendAgain {
      color: #4a90e2;
    }
  }
  .codeWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.15rem;
    .inputWrap {
      flex: 1 1 0%;
      position: relative;
      border-radius: 0.22rem;
      padding-left: 0.15rem;
      height: 0.44rem;
      line-height: 0.44rem;
      background: #f7f7f7;
      font-size: 0.16rem;
      color: #000;
      input {
        background: none;
        outline: none;
        border: none;
      }
      .del-btn {
        width: 0.13rem;
        height: 0.13rem;
        position: absolute;
        top: 0;
        right: 0;
        margin: 0.15rem 0.09rem;
      }
    }
    .codeImg {
      height: 0.36rem;
      width: 34.5%;
      background: rgb(238, 238, 238);
      margin-left: 0.1rem;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/authCode.vue